import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type EventReducedFragment = { __typename?: 'Event', id: string, external_zoho_id?: string | null, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, is_authorized_signer_necessary: boolean, currency: string, entity: Types.LegalEntity, type: Types.EventType, is_deleted: boolean, allowed_container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null, packing_unit?: number | null, segment?: Types.ContainerTypeSegment | null, color_hex_code?: string | null }>, allowed_item_types: Array<{ __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean }> };

export const EventReducedFragmentDoc = gql`
    fragment EventReduced on Event {
  id
  external_zoho_id
  name
  description
  image_url
  start_date
  end_date
  is_authorized_signer_necessary
  currency
  entity
  type
  is_deleted
  allowed_container_types {
    id
    name
    image
    packing_unit
    segment
    color_hex_code
  }
  allowed_item_types {
    id
    name
    image_url
    color_hex_code
    category
    archived
  }
}
    `;